<template>
    <AthModal @close="onClose">
        <template #content>
            <AthModalStandard :uiTitle="titleLbl" :uiIsGlobal="false" @close="onClose" class="br-m">
                <template #body>
                    <FormInput class="el--s-m sm-b-l"
                        :placeholder="placeholderLbl"
                        :lbl="inputLbl"
                        v-model="input_val"
                        :uiAutoFocus="true" />
                </template>
                <template #footer>
                    <AthButton class="el--s-m el--t-primary"
                        :disabled="input_val.length === 0"
                        @click="onSubmit"
                        :lbl="confirmLbl" />
                </template>
            </AthModalStandard>
        </template>
    </AthModal>
</template>

<script>
import AthModalStandard from '../modal-styles/Standard.vue';
import FormInput from '../../atoms/forms/FormInput.vue';
import AthButton from '../../atoms/Button.vue';
import AthModal from './Modal.vue';

export default {
    name: 'mead-standalone-input-confirm-modal',
    props: {
        /**
         * Title text (i18n key) displayed in the modal's header.
         */
        titleLbl: {type: String, default: ''},
        /**
         * Label text (i18n key) for the text input.
         */
        inputLbl: {type: String, default: 'mead.labels.name'},
        /**
         * Placeholder text (i18n key) shown in the text input when empty.
         */
        placeholderLbl: {type: String, default: 'mead.labels.name'},
        /**
         * Label text (i18n key) for the confirm/submit button, disabled while the input is empty.
         */
        confirmLbl: {type: String, default: 'mead.labels.submit'},
        /**
         * Initial value used to seed the internal input value (v-model'd on the text input).
         */
        value: {type: String, default: ''},
    },
    components: {AthModal, AthModalStandard, FormInput, AthButton},
    data () {
        return {
            input_val: this.value,
        };
    },
    methods: {
        onSubmit: function () {
            this.$emit('submit', this.input_val);
        },
        onClose: function () {
            this.$emit('close');
        },
    },
};
</script>
